import { Input, message, Table } from "antd";
import React, { useEffect } from 'react';
import styled from "styled-components";
import { Blacked } from "../../../../CRM/components/styles";
import { useToken } from "../../../../app/hooks";
import { HomeTownRoundCheckbox } from "../../../../app/organisms/Auth/Forms/HomeTownRoundCheckbox";
import { ReactComponent as ModalCloseIcon } from "../../../../assets/HomeTownIcon/ModalCloseIcon.svg";
import API from "../../../../utils/api";
import { formatPhoneNumber } from '../../../../utils/ciutils';
import { useAdminUserADList } from "../../../hooks/Admin/UserManage/GetAdminUserADList";
import { useAdminUserInfo } from "../../../hooks/Admin/UserManage/GetAdminUserInfo";
import {MEDIA_URL} from "../../../../app/constants/APIKEYS";
import {ReactComponent as DownloadIcon} from "../assets/DownloadIcon.svg";
import {handleDownload} from "../../../../utils/helpers";


type Props = {
  customerId: number | null;
  setCustomerId: (v: any) => void;
  mutateUserList: () => void;
};

export const AdStoreDetail: React.FC<Props> = ({ customerId, setCustomerId, mutateUserList }) => {
  // ====== 로컬 폼 상태 ======
  // 최초에는 null/''로 두고, 서버 값 도착 시 1회만 채움.
  const [premium, setPremium] = React.useState<number | null>(null);
  const [premiumChangeDate, setPremiumChangeDate] = React.useState<string>("");

  // 사용자가 한 번이라도 수정했는지
  const [didEdit, setDidEdit] = React.useState<boolean>(false);

  // 상세 모달 내에서 선택된 광고(미리보기)용
  const [commercialId, setCommercialId] = React.useState<number | null>(null);

  // 데이터 조회
  const { adminUserInfo } = useAdminUserInfo(customerId ?? undefined);
  const { adminUserADList } = useAdminUserADList(1, 1000, customerId ?? undefined);
  const { data: token } = useToken();

  // 디버깅
  useEffect(() => {
    console.log("adminUserInfo", adminUserInfo);
  }, [adminUserInfo]);

  useEffect(() => {
    console.log("adminUserADList", adminUserADList);
  }, [adminUserADList]);

  /**
   * 1) 고객이 바뀌면 폼 상태/플래그 리셋
   * 2) 서버 값이 들어오면 (didEdit=false일 때만) 1회 초기화
   */
  useEffect(() => {
    // 고객 변경 시 리셋
    setDidEdit(false);
    setPremium(null);
    setPremiumChangeDate("");

    // 서버값으로 초기 세팅 (adminUserInfo가 나중에 도착 가능)
  }, [customerId]);

  useEffect(() => {
    if (!adminUserInfo) return;

    // 사용자가 아직 수정하지 않았다면, 서버값으로 1회만 채움
    if (!didEdit) {
      setPremium((prev) =>
          prev === null ? (typeof adminUserInfo.premium === "number" ? adminUserInfo.premium : 0) : prev
      );
      setPremiumChangeDate((prev) =>
          prev === "" ? (adminUserInfo.premiumChangeDate ?? "") : prev
      );
    }
  }, [adminUserInfo, didEdit]);

  /**
   * 저장
   */
  const putEditUser = () => {
    const shouldEdit = window.confirm("수정하시겠습니까?");
    if (!shouldEdit || !customerId) return;

    API.put(`/admin/user/list/${customerId}`, token + "", {
      datas: {
        premium: Number(premium ?? 0), // null 방지
        premiumChangeDate: premiumChangeDate || ""
      }
    })
        .then((res: any) => {
          if (res.result?.success) {
            message.success("수정되었습니다");
            setCustomerId(null);
            mutateUserList();
          } else {
            message.error(res.result?.message || "실패하였습니다");
          }
        })
        .catch(() => {
          message.error("실패하였습니다");
        });
  };

  const columns: any[] = [
    {
      dataIndex: "adId",
      title: "No",
      render: (value: any) => (
          <div className="No." style={{ justifyContent: "center", display: "flex" }}>
            {value}
          </div>
      ),
    },
    {
      dataIndex: "title",
      title: "광고명",
      render: (value: any, data: any) => (
          <div
              className="No."
              onClick={() => setCommercialId(data?.adId)}
              style={{ justifyContent: "center", display: "flex" }}
          >
            {value}
          </div>
      ),
    },
    {
      dataIndex: "period",
      title: "광고기간",
      render: (value: any) => (
          <div className="type" style={{ justifyContent: "center", display: "flex" }}>
            {value}
          </div>
      ),
    },
    {
      dataIndex: "agentCount",
      title: "매체",
      render: (value: any) => (
          <div className="date" style={{ justifyContent: "center", display: "flex" }}>
            {(value || 0) + "곳"}
          </div>
      ),
    },
  ];

  const handleDownloadAll = async (fileList) => {
    try {
      await Promise.all(
          fileList.map(file => handleDownload(file.url, file.name))
      );
      message.success('모든 파일을 저장하였습니다.');
    } catch (error) {
      message.error('모든 파일 저장에 실패하였습니다.');
    }
  };

  console.log('//adminUserInfo',adminUserInfo)

  return (
      <>
        <Blacked onClick={() => setCustomerId(null)} />
        <ModalWrapper className={"scroll-container"}>
          <ModalHeader>
            <ModalTitle>광고물제작업체 상세</ModalTitle>
            <CloseIconSVG as={ModalCloseIcon} onClick={() => setCustomerId(null)} />
          </ModalHeader>

          <ContentsTitle>회원정보</ContentsTitle>
          <CustomTable>
            <tbody>
            <TableRow>
              <Th>
                <ThLabel>회원명</ThLabel>
              </Th>
              <Td colSpan={3}>{adminUserInfo?.name || "-"}</Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>아이디</ThLabel>
              </Th>
              <Td colSpan={3}>{adminUserInfo?.email || "-"}</Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>업체명</ThLabel>
              </Th>
              <Td>{adminUserInfo?.store || "-"}</Td>
              <Th>
                <ThLabel>업종</ThLabel>
              </Th>
              <Td>{adminUserInfo?.businessType || "-"}</Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>주소</ThLabel>
              </Th>
              <Td colSpan={3}>{adminUserInfo?.address || "-"}</Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>세부주소</ThLabel>
              </Th>
              <Td colSpan={3}>{adminUserInfo?.detailAddress || "-"}</Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>휴대폰</ThLabel>
              </Th>
              <Td>{formatPhoneNumber(adminUserInfo?.phone) || "-"}</Td>
              <Th>
                <ThLabel>가입일</ThLabel>
              </Th>
              <Td>{adminUserInfo?.createdAt || adminUserInfo?.cratedAt || "-"}</Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>계좌번호</ThLabel>
              </Th>
              <Td colSpan={3}>{adminUserInfo?.account || "-"}</Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>사용자 관리</ThLabel>
              </Th>
              <Td>
                <div style={{ display: "flex", gap: 14 }}>
                  <HomeTownRoundCheckbox
                      text={"유료"}
                      checked={premium === 1}
                      onClick={() => {
                        setDidEdit(true);
                        setPremium(1);
                      }}
                  />
                  <HomeTownRoundCheckbox
                      text={"무료"}
                      checked={premium === 0}
                      onClick={() => {
                        setDidEdit(true);
                        setPremium(0);
                      }}
                  />
                </div>
              </Td>

              <Th>
                <ThLabel>회원전환예정일</ThLabel>
              </Th>
              <Td>
                <InputText
                    placeholder={"ex. 2024-01-01"}
                    value={premiumChangeDate}
                    onChange={(e) => {
                      setDidEdit(true);
                      setPremiumChangeDate(e.target.value);
                    }}
                />
              </Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>포트폴리오</ThLabel>
              </Th>
              <Td colSpan={3}>
                <div>
                  <div style={{
                    display: 'flex',
                    fontWeight: '500',
                    fontSize: 14,
                    lineHeight: '16.71px',
                    marginBottom: 12
                  }}>
                    {`${adminUserInfo?.fileList?.length || 0}건`}
                    <div style={{fontWeight: '300', color: '#00000066', marginLeft: 6}}>|</div>
                    <div onClick={() => handleDownloadAll(adminUserInfo?.fileList)} style={{
                      fontWeight: '400',
                      color: '#125DE6CC',
                      textDecoration: 'underline',
                      marginLeft: 6,
                      cursor: 'pointer'
                    }}>모두저장
                    </div>
                  </div>

                  {adminUserInfo?.fileList?.map((item, index) => (
                      <div style={{
                        backgroundColor: '#FAFAFC',
                        height: 29,
                        padding: '6px 8px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: 4
                      }}>
                        <div>{item?.name}</div>
                        <DownloadSVG as={DownloadIcon}
                                     onClick={() => handleDownload(item?.url, item?.name)}/>
                      </div>
                  ))}
                </div>
              </Td>
            </TableRow>

            </tbody>
          </CustomTable>

          <ContentsTitle>
            진행중인 광고 <ContentsSubTitle>{`${adminUserADList?.length || 0}건`}</ContentsSubTitle>
          </ContentsTitle>

          <StyleTable columns={columns} dataSource={adminUserADList} pagination={false}/>

          {/*<ButtonsWrapper>*/}
          {/*  <CancelButton onClick={putEditUser}>수정</CancelButton>*/}
          {/*</ButtonsWrapper>*/}
        </ModalWrapper>

        {/* {commercialId !== null && <PreviewMonitor setCommercialId={setCommercialId} commercialId={commercialId} />} */}
      </>
  );
};

/* ====================== 스타일 (기존 유지) ====================== */

const DownloadSVG = styled.svg`
    cursor: pointer;
    width: 16px;
`

const InputText = styled(Input)`
  width: 160px;
  height: 28px;
  padding-left: 10px;
  border-radius: 4px;
  display: flex;

  &::placeholder {
    color: #535353;
  }
`;

const ModalWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 800px;
  width: 600px;
  min-height: 411px;
  background-color: #fff;
  overflow-y: auto;
  border-radius: 8px;
  padding: 24px;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const CloseIconSVG = styled.svg`
  width: 24px;
  cursor: pointer;
`;

const ModalTitle = styled.div`
  font-family: Pretendard, sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 21.48px;
  color: #2e2559;
`;

const CustomTable = styled.table`
  width: 100%;
  margin-top: 8px;
  border-collapse: collapse;
  border: 1px solid #ccc;
`;

const TableRow = styled.tr`
  min-height: 40px;
`;

const Th = styled.th`
  padding: 10px;
  text-align: left;
  width: 20%;
  border: 1px solid #ccc;
  background-color: #f4f2ff;
  vertical-align: middle;
`;

const ThLabel = styled.div`
  font-family: Pretendard, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 16.71px;
  color: #00000099;
`;

const Td = styled.td`
  padding: 10px;
  text-align: left;
  border: 1px solid #ccc;
  font-weight: 400;
  font-size: 14px;
  line-height: 16.71px;
`;

const ContentsTitle = styled.div`
  width: 100%;
  margin-top: 20px;
  font-family: Pretendard, sans-serif;
  font-weight: 600;
  font-size: 15px;
  line-height: 17.9px;
  color: #000000cc;
  display: flex;
  gap: 8px;
`;

const ContentsSubTitle = styled.div`
  font-family: Pretendard, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 16.75px;
  color: #000000cc;
`;

const ButtonsWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 6px;
`;

const CancelButton = styled.div`
  width: 100px;
  height: 40px;
  padding: 11px;
  border: 1px solid #000000;
  color: #000000;
  border-radius: 2px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  font-weight: 500;
  font-size: 15px;
  line-height: 17.9px;
  font-family: Pretendard, sans-serif;
`;

const StyleTable = styled(Table)`
  width: 532px;

  .ant-table-thead > tr > th {
    background-color: #f5f5f5;
    color: #00000099;
    font-size: 14px;
    font-weight: 500;
    line-height: 16.71px;
    text-align: center;
  }
`;
